import { render } from "./App.vue?vue&type=template&id=7deb6cfa"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7deb6cfa&lang=css"

import exportComponent from "/home/runner/work/rights.tokyo/rights.tokyo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__